module.exports = __webpack_public_path__ + "static/media/submenu-pesquisa.9ce57da6.svg";